<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <prefecture-select v-model="value"
                       :class="errorMessage ? 'is-invalid' : ''"
                       :set-handler="setPrefecture"
                       :value="value"
    />
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>
<script>
import FormLayout from "@/views/templates/FormLayout";
import PrefectureSelect from "@/views/atoms/inputs/PrefectureSelect";
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem'

export default {
  name: "VuexPrefectureFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: false,
      default: '都道府県'
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    bind: {
      type: String,
      default: 'prefecture_code'
    },
  },
  components: {
    PrefectureSelect,
    FormLayout
  },
  methods: {
    setPrefecture(payload) {
      this.value = parseInt(payload.value);
    }
  },
}
</script>
